import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useMemo, useState } from 'react';
import { useEthers } from './useEthers';
import { useReadonlyNetworks } from '../providers/network/readonlyNetworks';
import { useBlockNumber, useBlockNumbers } from '../hooks';
/**
 * Returns gas price of current network.
 * @public
 * @returns gas price of current network. `undefined` if not initialised.
 */
export function useGasPrice() {
  var queryParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _useEthers = useEthers(),
    library = _useEthers.library;
  var providers = useReadonlyNetworks();
  var _blockNumber = useBlockNumber();
  var blockNumbers = useBlockNumbers();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    gasPrice = _useState2[0],
    setGasPrice = _useState2[1];
  var chainId = queryParams.chainId;
  var _useMemo = useMemo(function () {
      return chainId ? [providers[chainId], blockNumbers[chainId]] : [library, _blockNumber];
    }, [providers, library, blockNumbers, _blockNumber]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    provider = _useMemo2[0],
    blockNumber = _useMemo2[1];
  function updateGasPrice() {
    return _updateGasPrice.apply(this, arguments);
  }
  function _updateGasPrice() {
    _updateGasPrice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = setGasPrice;
            _context.next = 3;
            return provider === null || provider === void 0 ? void 0 : provider.getGasPrice();
          case 3:
            _context.t1 = _context.sent;
            (0, _context.t0)(_context.t1);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _updateGasPrice.apply(this, arguments);
  }
  useEffect(function () {
    void updateGasPrice();
  }, [provider, blockNumber]);
  return gasPrice;
}